import a1 from '../alphabet/sound-assets/1.mp3';
import a2 from '../alphabet/sound-assets/2.mp3';
import a3 from '../alphabet/sound-assets/3.mp3';
import a4 from '../alphabet/sound-assets/4.mp3';
import a5 from '../alphabet/sound-assets/5.mp3';
import a6 from '../alphabet/sound-assets/6.mp3';
import a7 from '../alphabet/sound-assets/7.mp3';
import a8 from '../alphabet/sound-assets/8.mp3';
import a9 from '../alphabet/sound-assets/9.mp3';
import a10 from '../alphabet/sound-assets/10.mp3';
import a11 from '../alphabet/sound-assets/11.mp3';
import a12 from '../alphabet/sound-assets/12.mp3';
import a13 from '../alphabet/sound-assets/13.mp3';
import a14 from '../alphabet/sound-assets/14.mp3';
import a15 from '../alphabet/sound-assets/15.mp3';
import a16 from '../alphabet/sound-assets/16.mp3';
import a17 from '../alphabet/sound-assets/17.mp3';
import a18 from '../alphabet/sound-assets/18.mp3';
import a19 from '../alphabet/sound-assets/19.mp3';
import a20 from '../alphabet/sound-assets/20.mp3';
import a21 from '../alphabet/sound-assets/21.mp3';
import a22 from '../alphabet/sound-assets/22.mp3';
import a23 from '../alphabet/sound-assets/23.mp3';
import a24 from '../alphabet/sound-assets/24.mp3';
import a25 from '../alphabet/sound-assets/25.mp3';
import a26 from '../alphabet/sound-assets/26.mp3';
import a27 from '../alphabet/sound-assets/27.mp3';
import a28 from '../alphabet/sound-assets/28.mp3';
import a29 from '../alphabet/sound-assets/29.mp3';
export const alphabet = [
  {
    id: 0,
    text: 'A a',
    audio: a1,
  },
  {
    id: 1,
    text: 'Ă ă',
    audio: a2,
  },
  {
    id: 2,
    text: 'Â â',
    audio: a3,
  },
  {
    id: 3,
    text: 'B b',
    audio: a4,
  },
  {
    id: 4,
    text: 'C c',
    audio: a5,
  },
  {
    id: 5,
    text: 'D d',
    audio: a6,
  },
  {
    id: 6,
    text: 'Đ đ',
    audio: a7,
  },
  {
    id: 7,
    text: 'E e',
    audio: a8,
  },
  {
    id: 8,
    text: 'Ê ê',
    audio: a9,
  },
  {
    id: 9,
    text: 'G g',
    audio: a10,
  },
  {
    id: 10,
    text: 'H h',
    audio: a11,
  },
  {
    id: 11,
    text: 'I i',
    audio: a12,
  },
  {
    id: 12,
    text: 'K k',
    audio: a13,
  },
  {
    id: 13,
    text: 'L l',
    audio: a14,
  },
  {
    id: 14,
    text: 'M m',
    audio: a15,
  },
  {
    id: 15,
    text: 'N n',
    audio: a16,
  },
  {
    id: 16,
    text: 'O o',
    audio: a17,
  },
  {
    id: 17,
    text: 'Ô ô',
    audio: a18,
  },
  {
    id: 18,
    text: 'Ơ ơ',
    audio: a19,
  },
  {
    id: 19,
    text: 'P p',
    audio: a20,
  },
  {
    id: 20,
    text: 'Q q',
    audio: a21,
  },
  {
    id: 21,
    text: 'R r',
    audio: a22,
  },
  {
    id: 22,
    text: 'S s',
    audio: a23,
  },
  {
    id: 23,
    text: 'T t',
    audio: a24,
  },
  {
    id: 24,
    text: 'U u',
    audio: a25,
  },
  {
    id: 25,
    text: 'Ư ư',
    audio: a26,
  },
  {
    id: 26,
    text: 'V v',
    audio: a27,
  },
  {
    id: 27,
    text: 'X x',
    audio: a28,
  },
  {
    id: 28,
    text: 'Y y',
    audio: a29,
  },
];
